module.exports = __webpack_public_path__ + "static/media/strip1_resized.ba67e6e3.png";